import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigService } from '../../../core/config/config.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FileSaverService {
  constructor(
    private http: HttpClient,
    private config: ConfigService
  ) {}

  private getFileExtension(url: string) {
    const extension = url.split('.').pop()?.toLowerCase();
    const validExtensions = ['pdf', 'jpeg', 'jpg', 'png', 'gif'];
    return validExtensions.includes(extension!) ? extension : null;
  }

  getFile(id: string): Observable<any> {
    const headers = new HttpHeaders().set('Bypass-Interceptor', 'true');
    const requestOptions: Object = { headers: headers };

    return this.http.get(
      this.config.apiUrl + `/ServiceDesk/api/Requests/ViewFile/${id}`,
      requestOptions
    );
  }

  getBas64File(fileName: string): Observable<any> {
    return this.http.post(
      this.config.apiUrl + '/FileService/api/Attachment/View/Base',
      [fileName]
    );
  }

  getBase64ImageSrc(base64: string, fileName: string): string {
    return `data:image/${fileName
      .split('.')
      [fileName.split('.').length - 1].toLowerCase()};base64,${base64}`;
  }

  base64ToBlob(
    base64: string,
    extensionData?: string,
    fileUrl?: string
  ): { blob: Blob; extension: string } {
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);

    const extension: string | undefined | null = extensionData
      ? extensionData
      : fileUrl
        ? this.getFileExtension(fileUrl as string)
        : 'pdf';

    const blob = new Blob([byteArray], {
      type: `application/${extension}`
    });

    return { blob: blob, extension: extension ? extension : 'pdf' };
  }
}
